// Module
var code = "<nvd3 options=\"options\" data=\"data\"></nvd3> ";
// Exports
module.exports = code;